import { getrlStdFlrAll, getrlFloor } from "@/mixins/LiteModuleDb.js";
import { deleteFirstRevokeData } from "@/mixins/initRevokeData.js";
import { getConstructType } from "@/api/project";
export default {
  namespaced: true,
  state: {
    rl_stdFlr_id: "", // 当前标准层ID
    rl_wasm_module: "", // wasm实例
    current_sel_ent: "", // 当前选中的实体对象
    rl_floor_arr: [], // 当前自然层列表
    rl_stdFlr_arr: [], // 当前标准层列表
    currentMcDbId: null, // 当前绘制轴线的mcDbId
    currentArcMcDbId: null, // 当前绘制圆弧的mcDbId
    dimensionObj: null, // 用于存储 gridCopy 和其他操作相关的标注对象
    mDimensionId: null, // 用于存储 mDimensionId
    // 模型最大序号
    rl_struct_num: {
      rlColSeg: null,
      rlBeamSeg: null,
      rlWallSeg: null,
      rlSlab: null,
      rlFloor: 1,
      rlRingBeamSeg: null,
      rlStdFlr: 1,
      rlSubBeam: null,
    },
    rlAxisLineLoad: [], // 加载的轴线
    // 当前绘制的步
    drawStep: 1,
    canAddRawStep: false, // 是否可以添加绘制步数，若为false，则不能添加撤销回退数据
    isReDo: false, // 是否正处于撤销中
    revokeDataLength: 0, // 撤销步数
    revokeRollbackLength: 0, // 回退步数
    isBldg: false, // 是否是整栋绘制
    menuData: null, // 当前选中的菜单
    downMenuChickData: null, // 下方按钮点击的功能
    hiddenKeysForLeftBox: [],
    hiddenKeysForRightBox: [],
    databaseStore: {}, //indexbd过程存储数据,增删改为一组数据
    revokeDataStore: {}, //indexbd撤销回退数据，增删改为一组数据
    isSketch: false, //是否是草图模式,false:正图,true:草图
    databaseStore: {}, // indexbd过程存储数据,增删改为一组数据
    revokeDataStore: {}, // indexbd撤销回退数据，增删改为一组数据
    constructType: {}, // 获取检测-强度-获取类型
    baseLineId: null, // 批量对齐的基准线
    freePartitionWallPoints: [], // 自由隔墙数据
    isSaveEnd: null, //null->还没有保存过，为false为在保存中，为true为保存成功
  },
  mutations: {
    setIsSaveEnd(val) {
      state.isSaveEnd = val;
    },
    // 设置自由隔墙数据
    setFreePartitionWallPoints(state, obj) {
      state.freePartitionWallPoints = obj;
    },
    // 设置菜单数据
    setMenuData(state, n) {
      state.menuData = n;
    },

    // 设置mDimensionId
    setmDimensionId(state, n) {
      state.mDimensionId = n;
    },

    // 设置dimensionObj
    setDimensionObj(state, obj) {
      state.dimensionObj = obj;
    },

    setHiddenKeysForLeftBox(state, { keys, hide }) {
      if (hide) {
        state.hiddenKeysForLeftBox = Array.from(
          new Set([...state.hiddenKeysForLeftBox, ...keys])
        );
      } else {
        state.hiddenKeysForLeftBox = state.hiddenKeysForLeftBox.filter(
          (key) => !keys.includes(key)
        );
      }
    },

    setHiddenKeysForRightBox(state, { keys, hide }) {
      if (hide) {
        state.hiddenKeysForRightBox = Array.from(
          new Set([...state.hiddenKeysForRightBox, ...keys])
        );
      } else {
        state.hiddenKeysForRightBox = state.hiddenKeysForRightBox.filter(
          (key) => !keys.includes(key)
        );
      }
    },

    setDefaultHiddenKeys(state, { leftKeys, rightKeys }) {
      state.hiddenKeysForLeftBox = leftKeys;
      state.hiddenKeysForRightBox = rightKeys;
    },

    // 设置是否整栋
    setIsBldg(state, n) {
      state.isBldg = n;
    },
    setIsSketch(state, n) {
      state.isSketch = n;
    },
    SET_REDO(state, n) {
      state.isReDo = n;
    },
    // 绘制步数+1
    async addRawStep(state, n) {
      if (n == "Revoke") {
        state.drawStep--;
      } else if (n == "Rollback") {
        state.drawStep++;
      } else {
        state.isReDo = false;
        if (state.drawStep > 19) {
          await deleteFirstRevokeData();
        } else state.drawStep++;
      }
    },
    // 设置是否可以添加绘制步数
    setCanAddRawStep(state, canAddRawStep) {
      state.canAddRawStep = canAddRawStep;
    },
    // 清空绘制步数
    clearRawStep(state) {
      state.drawStep = 1;
    },
    setRevokeDataLength(state, revokeDataLength) {
      state.revokeDataLength = revokeDataLength;
    },
    setRevokeRollbackLength(state, revokeRollbackLength) {
      state.revokeRollbackLength = revokeRollbackLength;
    },
    // 赋值轴线
    addGuidToRlAxisLineLoad(state, Guid) {
      state.rlAxisLineLoad.push(Guid);
    },
    deleteGuidToRlAxisLineLoad(state, Guid) {
      state.rlAxisLineLoad = state.rlAxisLineLoad.filter(
        (item) => item != Guid
      );
    },
    clearGuidToRlAxisLineLoad(state) {
      state.rlAxisLineLoad = [];
    },
    // 赋值当前标准层ID
    setStdFlr(state, Guid) {
      state.rl_stdFlr_id = Guid;
    },
    // 赋值wasm实例
    setWasmModule(state, object) {
      state.rl_wasm_module = object;
    },
    // 赋值当前选中的实体对象
    setCurrentSelEnt(state, obj) {
      state.current_sel_ent = obj;
    },
    // 设置当前自然层列表
    setFloorArr(state, res) {
      state.rl_floor_arr = res;
    },
    // 设置当前标准层列表
    setStdFlrArr(state, res) {
      state.rl_stdFlr_arr = res;
    },
    // 设置重置模型最大序号
    setStructNum(state, obj) {
      state.rl_struct_num = obj;
    },
    // 设置单个模型最大序号数值-赋值
    setStructKeyNum(state, { key, val }) {
      if (val == 1) {
        state.rl_struct_num[key] = {
          [state.rl_stdFlr_id]: {
            No_: 1,
            StdFlrGuid: state.rl_stdFlr_id,
          },
        };
      } else {
        state.rl_struct_num[key][state.rl_stdFlr_id].No_ = val; // 直接赋新值
      }
    },
    // 设置下方按钮点击的功能
    setDownMenuChickData(state, obj) {
      state.downMenuChickData = obj;
    },
    // 设置数据库存储数据
    setDatabaseStore(state, { type, obj }) {
      if (!type && !obj) {
        state.databaseStore = {};
        return;
      }
      if (!state.databaseStore[type]) {
        state.databaseStore[type] = [];
      }
      state.databaseStore[type].push(obj);
    },
    setRevokeDataStore(state, { type, obj }) {
      if (!type && !obj) {
        state.revokeDataStore = {};
        return;
      }
      if (!state.revokeDataStore[type]) {
        state.revokeDataStore[type] = [];
      }
      if (
        !state.revokeDataStore[type].filter((item) => item.Guid == obj.Guid)
          .length
      ) {
        state.revokeDataStore[type].push(obj);
      }
    },
    setConstructType(state, res) {
      state.constructType = res;
    },
    // 设置当前绘制轴线的mcDbId
    setCurrentMcDbId(state, id) {
      state.currentMcDbId = id;
    },
    // 设置当前圆弧的mcDbId
    setCurrentArcMcDbId(state, id) {
      state.currentArcMcDbId = id;
    },
    // 设置批量对齐的基准线
    setBaseLineId(state, id) {
      state.baseLineId = id;
    },
  },
  actions: {
    // 获取当前自然层列表
    async getFloorArr(store) {
      const res = await getrlFloor();
      store.commit("setFloorArr", res);
      return res;
    },
    // 获取当前标准层列表
    async getStdFlrArr(store) {
      const res = await getrlStdFlrAll(true);
      store.commit("setStdFlrArr", res);
      return res;
    },
    // 获取当前构件最大值
    async getStructNum(store, key) {
      const currentStructNum = store.state.rl_struct_num[key]; // 先访问属性以避免重复访问
      var val =
        currentStructNum && currentStructNum[store.state.rl_stdFlr_id]
          ? +currentStructNum[store.state.rl_stdFlr_id].No_ + 1
          : 1;
      store.commit("setStructKeyNum", { key, val });
      return val;
    },
    // 获取强度-获取类型
    async getConstructType(store) {
      const res = await getConstructType();
      store.commit("setConstructType", res.data || {});
      return res;
    },
  },
  getters: {},
};

//
// store.state.rl_struct_num[key] = {
//   [store.state.rl_stdFlr_id]: {
//     No_: 1,
//     StdFlrGuid: store.state.rl_stdFlr_id,
//   },
// };
